// Textos compartidos: barra de navegación, pie de página, selector de idioma.
// Traducción de fr/common.js — exactamente las mismas claves.
// Las claves packs.* SOLO viven en este fragmento (tp/tpList las leen, con
// respaldo en el valor que llega de la base de datos).
// El tunel de compra trata de «usted»; el bloque newsletter del pie tutea,
// igual que el francés y el neerlandés.
export default {
  'nav.home': 'Inicio',
  'nav.shop': 'Tienda',
  'nav.rules': 'Reglas del juego',
  'nav.about': 'Sobre nosotros',
  'nav.contact': 'Contacto',
  'nav.cart': 'Mi carrito',
  'nav.admin': 'Administración',
  'nav.adminShort': 'Admin',
  'nav.adminTitle': 'Acceso admin',
  'nav.order': 'Comprar',
  'nav.cartEmpty': 'Su carrito está vacío',
  'nav.checkout': 'Proceder al pago',
  'nav.login': 'Iniciar sesión',
  'nav.loginShort': 'Acceder',
  'nav.logout': 'Cerrar sesión',
  'nav.orders': 'Pedidos',
  'nav.myOrders': 'Mis pedidos',
  'nav.profile': 'Perfil',
  'nav.myProfile': 'Mi perfil',
  'nav.language': 'Idioma',

  'footer.tagline':
    '¡Creemos momentos mágicos en familia! Nuestros puzles convierten la revelación del sexo del bebé en una aventura inolvidable.',
  'footer.badge.interactive': '🎲 Interactivo',
  'footer.badge.festive': '🎊 Festivo',
  'footer.badge.family': '💝 Familia',
  'footer.nav': 'Navegación',
  'footer.legal': 'Legal',
  'footer.privacy': 'Privacidad',
  'footer.terms': 'Condiciones generales',
  'footer.paymentSecurity': 'Seguridad de pago',
  'footer.legalNotice': 'Aviso legal',
  'footer.connected': 'Sigue conectado',
  'footer.newsletter': 'Recibe las últimas novedades:',
  'footer.newsletterPlaceholder': 'tu@email.com',
  'footer.madeWith': 'Creado con',
  'footer.madeFor': 'para familias mágicas.',

  // Textos de producto (normalmente vienen de la base de datos, aquí
  // traducidos vía tp/tpList). Los nombres de los packs son marca: no se
  // traducen, igual que en neerlandés.
  'packs.flash.name': 'Pack Essentiel',
  'packs.flash.description': 'Solo la caja del juego: el resto lo prepara usted.',
  'packs.flash.longDescription':
    'Usted recibe la caja Joyful Reveal y nada más: once piezas de puzle que se van ganando pregunta a pregunta, y la duodécima para rascar, la que lo revela todo. Las reglas están resumidas en el dorso de la caja y también disponibles en línea. Las preguntas las escribe usted, igual que prepara algo para distinguir a los dos equipos. Si prefiere que llegue todo listo, eche un vistazo al Pack Premium.',
  'packs.flash.features':
    'La caja del juego y sus 12 piezas|11 piezas por ganar + 1 pieza rascable|Reglas resumidas en el dorso de la caja|Versión en línea de las reglas con el código QR',

  'packs.premium.name': 'Pack Premium',
  'packs.premium.description': 'El juego completo: todo está listo, solo tiene que recibirlo.',
  'packs.premium.longDescription':
    'Todo lo que trae la caja, más los tres accesorios que cambian la fiesta: dos bolsitas de algodón para distinguir a los equipos, el cuestionario impreso en cartón de 400 g con las once preguntas ya escritas y una plantilla en blanco para inventar las suyas, y un sobre de recuerdo para deslizar detrás de un marco cuando termine la fiesta.',
  'packs.premium.features':
    'La caja del juego y sus 12 piezas|2 bolsitas de algodón para los dos equipos|El cuestionario impreso en cartón de 400 g|Una plantilla en blanco para sus propias preguntas|El sobre de recuerdo para guardar después de la fiesta',
  "footer.maFacture": "Recuperar mi factura",
};
